/**
 * Masthead fiddle logo with floating notes.
 * Same icon in the corner widget and the open player.
 */
import React from 'react';

const LOGO_SRC = '/images/android-chrome-192x192.png';

const PlayingFiddleMark = ({ playing = false, size = 'panel' }) => (
  <div
    className={`fiddle-mark fiddle-mark--${size}${playing ? ' is-playing' : ''}`}
    aria-hidden="true"
  >
    <img
      src={LOGO_SRC}
      alt=""
      className="fiddle-mark-art"
      draggable="false"
    />
    <span className="fiddle-note n1">♪</span>
    <span className="fiddle-note n2">♫</span>
    <span className="fiddle-note n3">♪</span>
  </div>
);

export default PlayingFiddleMark;
